import * as React from "react";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import moment from "moment";
import * as Data from "../../Data";
import * as Dati from "../../Dati";
import * as Glob from "../../Globale";
import { ChiamaAPI, Trad, BaseComponent, Tipo } from "..";
import { DateRange } from "../../components/custom/DateRange/DateRange";
import { PortletToogleIcon } from "../common/PortletToogleIcon";
import * as Dashboard from "./Dashboard";
import { IInitialDates, GetInitialDates } from "./DashboardHelpers";
import { DateRangeData, DateRanges, GetDateRange } from "../../helpers/DateHelper";

interface IDashboardIssued {
    IsIssuedComparison?: boolean;
}

interface IDashboardIssuedState {
    Area: string;
    Product: string;
    Type: string;
    Aggiorna: number;
    DateFrom: Data.CData;
    DateTo: Data.CData;
}

export class DashboardIssued extends BaseComponent<IDashboardIssued, IDashboardIssuedState> {
    private _Area: Dati.TDictTipo = {};
    private _Product: Dati.TDictTipo = {};
    private _Type: Dati.TDictTipo = {};
    private _InitialDates: IInitialDates = GetInitialDates();
    private _InitialDatesRange: DateRangeData = GetDateRange(DateRanges.CurrentMonth);

    public constructor(props: any) {
        super(props);

        this.state = {
            Area: "0",
            Product: "0",
            Type: "Fatturato",
            Aggiorna: 1,
            DateFrom: new Data.CData(this._InitialDatesRange.DateFrom),
            DateTo: new Data.CData(this._InitialDatesRange.DateTo)
        };

        this.OnChange = this.OnChange.bind(this);
        this.OnRangeChange = this.OnRangeChange.bind(this);

        this._Area["1"] = new Dati.CTipo("0", "All");
        this._Area["2"] = new Dati.CTipo("1", "Fideiussioni");
        this._Area["3"] = new Dati.CTipo("2", "RCP");

        this._Product["1"] = new Dati.CTipo("0", "All");

        this._Type["1"] = new Dati.CTipo("Fatturato", "Fatturato");
        this._Type["2"] = new Dati.CTipo("NumeroPolizze", "Policies Number");
    }

    componentDidMount() {
        setInterval(() => {
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
        }, Dashboard.SecondsAutomaticUpdate * 1000);
    }

    private getLabelName(label: string): string {
        return label.split(" - ")[1];
    }

    private setDatasetColors(dataset: any, i: number, rgba: number) {
        for (let x: number = 0; x < dataset.data.length; x++) {
            dataset.borderColor.push(Glob.ColoreStaticA(i, rgba));
            dataset.backgroundColor.push(Glob.ColoreStaticA(i, rgba));
        }
    }

    private OnResIssued(sender: ChiamaAPI, dati: Dati.CRisAPIDato<Dati.ChartData>, datiNuovi: boolean): React.ReactNode {
        const IsIssuedComparison = this.props.IsIssuedComparison;
        const datasets = dati.Dato.datasets;
        const options = {
            maintainAspectRatio: false,
            borderWidth: 1,
            scales: {
                yAxes: [
                    {
                        stacked: !IsIssuedComparison
                    }
                ],
                xAxes: [
                    {
                        scaleLabel: {
                            display: !IsIssuedComparison,
                            labelString: Trad.Trad("Year - Month - Week")
                        }
                    }
                ]
            },
            legend: {
                onClick: () => {}
            }
        };

        const usedColors: any = [];

        for (let i: number = 0; i < datasets.length; i++) {
            datasets[i].borderColor = [];
            datasets[i].backgroundColor = [];

            if (!IsIssuedComparison) {
                datasets[i].label = Trad.Trad(datasets[i].label || "");
                datasets[i].borderColor.push(Glob.ColoreStaticA(i));
                datasets[i].backgroundColor.push(Glob.ColoreStaticA(i));
            } else {
                const name = this.getLabelName(datasets[i].label || "");
                const connectedObj = usedColors.find((obj: any) => obj.name === name);

                if (!connectedObj) {
                    usedColors.push({ name, i });
                    this.setDatasetColors(datasets[i], i, 0.5);
                } else {
                    this.setDatasetColors(datasets[i], connectedObj.i, 0.8);
                }
            }
        }

        if (!IsIssuedComparison) {
            dati.Dato.labels = dati.Dato.labels.map(label => moment(label, "YYYY - WW").format("YYYY-MM-WW"));
        }

        return dati.Dato.labels.length ? (
            <div className="chart-wrapper">{this.props.IsIssuedComparison ? <Bar data={dati.Dato} options={options} type="bar" /> : <Line data={dati.Dato} options={options} type="line" />}</div>
        ) : (
            <div className="kt-widget4">
                <div className="kt-widget4__item">
                    <p className="kt-font-info">{Trad.Trad("Nessun dato presente")}</p>
                </div>
            </div>
        );
    }

    public OnRangeChange(value: DateRangeData) {
        this.setState({
            DateFrom: value ? new Data.CData(value.DateFrom) : this._InitialDates.DateFrom,
            DateTo: value ? new Data.CData(value.DateTo) : this._InitialDates.DateTo
        });
    }

    public render() {
        const { IsIssuedComparison } = this.props;
        const Url = IsIssuedComparison
            ? `/api/Polizza/EmessoConConfronto?id_TipoRamo=${this.state.Area}&id_TipoProdotto=${this.state.Product}&TipoConfronto=${this.state.Type}&dataInizio=${this.state.DateFrom.DataBreve}&dataFine=${this.state.DateTo.DataBreve}`
            : `/api/Polizza/Emesso?id_TipoRamo=${this.state.Area}&id_TipoProdotto=${this.state.Product}&dataInizio=${this.state.DateFrom.DataBreve}&dataFine=${this.state.DateTo.DataBreve}`;

        return (
            <div className="kt-portlet portlet-shadow kt-portlet--sortable" data-ktportlet="true">
                <div className="kt-portlet__head ui-sortable-handle">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-label">{Trad.Trad(IsIssuedComparison ? "Comparison issued" : "Issued")}</h3>
                    </div>
                    <div className="kt-portlet__head-toolbar">
                        <PortletToogleIcon />
                    </div>
                </div>
                <div className="kt-portlet__body">
                    <div className="kt-widget4">
                        <DateRange DateFrom={this.state.DateFrom.DataBreve} DateTo={this.state.DateTo.DataBreve} OnChange={this.OnChange} OnRangeChange={this.OnRangeChange} />

                        <ChiamaAPI Aggiornare={this.state.Aggiorna} URL={Url} OnRis={(s, d, dn) => this.OnResIssued(s, d, dn)} OnErrore={this.OnErrore} ImmaginePrecaricamento={true} />
                        <div className="row">
                            <div className="col-lg-6">
                                <label>{Trad.Trad("Area")}</label>
                                <Tipo
                                    Dati={this._Area}
                                    Campo="Area"
                                    ID_ChiaveString={this.state.Area || ""}
                                    OnAggiorna={(c, v) => {
                                        if (v === "0") {
                                            this.setState({
                                                Product: "0",
                                                Area: v
                                            });
                                        } else {
                                            this.setState({ Area: v });
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-lg-6">
                                <label>{Trad.Trad("Prodotto")}</label>
                                <Tipo
                                    Dati={this.state.Area === "0" ? this._Product : undefined}
                                    URL={this.state.Area !== "0" ? `/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto&parametri=${this.state.Area}` : undefined}
                                    Campo="Product"
                                    ID_ChiaveString={this.state.Product || ""}
                                    OnAggiorna={(c, v) => {
                                        this.setState({ Product: v });
                                    }}
                                    Ordinato
                                />
                            </div>
                        </div>
                        {IsIssuedComparison && (
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>{Trad.Trad("Tipo")}</label>
                                    <Tipo
                                        Dati={this._Type}
                                        Campo="Type"
                                        ID_ChiaveString={this.state.Type || ""}
                                        OnAggiorna={(c, v) => {
                                            this.setState({ Type: v });
                                        }}
                                        Ordinato
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardIssued.tsx